import { useState, Fragment } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { formLabel } from '../../../_elements/formLabel';
import { FiSettings } from 'react-icons/fi';
import { getTeamIdFromURL } from '@/_helpers';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';
import { miniSiteApi } from '@/_services/api/miniSite';
import { VscLoading } from 'react-icons/vsc';
const MINISITE_BASE_URL = 'https://optonome.com/';

const normalizeSlug = (value = '') =>
    String(value || '')
        .toLowerCase()
        .trim();

function Component() {
    const teamId = getTeamIdFromURL();
    const [show, setShow] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const handleClose = () => {
        setShow(false);
        setSlug('');
    };

    const fetchMiniwebsite = async () => {
        if (!teamId) {
            return;
        }

        try {
            setIsBusy(true);
            const response = await miniSiteApi.getMinisiteMapping(teamId);
            setSlug(normalizeSlug(response?.slug || ''));
        } catch (err) {
            if (err?.name === 'AbortError') return;
            toast.error(err?.message || 'Unable to fetch miniwebsite settings');
        } finally {
            setIsBusy(false);
        }
    };

    const handleShow = async () => {
        setShow(true);
        await fetchMiniwebsite();
    };

    const [slug, setSlug] = useState('');
    const previewUrl = slug ? `${MINISITE_BASE_URL}${slug}` : '';

    const onSave = async () => {
        const trimmedSlug = normalizeSlug(slug);
        if (!trimmedSlug) {
            return toast.error('Slug is required');
        }

        try {
            setIsSaving(true);
            const response = await miniSiteApi.updateMinisiteMapping(teamId, {
                slug: trimmedSlug,
            });
            setSlug(normalizeSlug(response?.slug || trimmedSlug));
            toast.success('Miniwebsite slug updated');
        } catch (err) {
            toast.error(err?.message || 'Unable to update miniwebsite slug');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Fragment>
            <div className="action-btn ml-2" onClick={handleShow}>
                <FiSettings />
            </div>

            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className="modal-headers">Edit Team Settings</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label css={formLabel} style={{ fontWeight: 700 }}>
                            Minisite Url
                        </Form.Label>
                        {isBusy && <VscLoading className="spin ml-2" />}
                        <Form.Control
                            type="text"
                            name="slug"
                            placeholder="e.g. mysite-name"
                            value={slug}
                            onChange={(e) => setSlug(normalizeSlug(e.target.value))}
                        />
                        {!!previewUrl && (
                            <div className="mt-2">
                                <span className="mr-2">Preview:</span>
                                <a href={previewUrl} target="_blank" rel="noopener noreferrer">
                                    {previewUrl}
                                </a>
                            </div>
                        )}
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={onSave} disabled={isSaving || isBusy}>
                        {isSaving ? 'Saving...' : 'Save'}
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
}

const EditTeamSettings = (props) => (
    <ComponentErrorBoundary componentErrorMessage={props?.componentErrorMessage}>
        <Component {...props} />
    </ComponentErrorBoundary>
);
export default EditTeamSettings;
